<template>
  <div class="container">
    <!-- 日期选择器 -->
    <el-row>
      <el-col>
        <el-form :inline="true" size="small">
          <el-form-item>
            <el-config-provider :locale="zhCn">
              <el-date-picker
                  v-model="listQuery.DTStartCreatedDate"
                  type="date"
                  placeholder="开始时间"
                  value-format="YYYY-MM-DD"
                  :disabled-date="disabledDate"
                  @change="validateDate"
              />
            </el-config-provider>
          </el-form-item>
          <el-form-item>
            <el-config-provider :locale="zhCn">
              <el-date-picker
                  v-model="listQuery.DTEndCreatedDate"
                  type="date"
                  placeholder="结束时间"
                  value-format="YYYY-MM-DD"
                  :disabled-date="disabledDate"
                  @change="validateDate"
              />
            </el-config-provider>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="fetchData">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="resetFilter">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-table
        v-loading="listLoading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%; margin-top: 20px;"
    >
      <el-table-column label="藏书地点" align="center" prop="StrLibraryName" />
      <el-table-column label="期间藏书量(册)" align="center" prop="IntBookCount" />
      <el-table-column label="借出次数(册)" align="center" prop="IntBorrowCount" />
      <el-table-column label="还书次数(册)" align="center" prop="IntReturnCount" />
      <el-table-column label="续借次数(册)" align="center" prop="IntRenewCount" />
      <el-table-column label="超期数量(册)" align="center" prop="IntOverdueCount" />
      <el-table-column label="图书流通率(%)" align="center">
        <template #default="{ row }">
          {{ (row.FloatBookCirculationRate ).toFixed(2) }}%
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import { ElMessage } from 'element-plus'
import {BASE_URL} from "@/utils/constants";
import {toUTCDateTime} from "@/utils/date";
export default {
  name: 'BookHousesSatistics',
  data() {
    return {
      list: [],
      listLoading: false,
      listQuery: {
        DTStartCreatedDate: '',
        DTEndCreatedDate: ''
      }
    }
  },
  computed: {
    zhCn() {
      return zhCn
    }
  },
  methods: {
    disabledDate(time) {
      return time.getTime() > Date.now()
    },
    validateDate() {
      const start = new Date(this.listQuery.DTStartCreatedDate)
      const end = new Date(this.listQuery.DTEndCreatedDate)
      if (start && end && end < start) {
        ElMessage.error('结束时间不能小于开始时间')
        this.listQuery.DTEndCreatedDate = ''
      }
    },
    resetFilter() {
      this.listQuery.DTStartCreatedDate = ''
      this.listQuery.DTEndCreatedDate = ''
      this.fetchData()
    },
    fetchData() {
      const parem = {
        Search:{}
      };
      // 处理日期范围，确保时间参数非空且有效
      var end = this.listQuery.DTEndCreatedDate;
      if (end !== undefined && end !== null && end !== '' && end !== 'null') {
        var start = this.listQuery.DTStartCreatedDate;
        if (start !== undefined && start !== null && start !== '' && start !== 'null') {
          parem.Search.DTStartCreatedDate = toUTCDateTime(this.listQuery.DTStartCreatedDate, 'start');
        }
        parem.Search.DTEndCreatedDate = toUTCDateTime(this.listQuery.DTEndCreatedDate, 'end');
      }

      this.listLoading = true
      this.$axios({
        url: BASE_URL + 'organizations/datasbylibs',
        method: 'post',
        data: JSON.stringify(parem),
        // 发送格式为 json
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.ok) {
          this.list = res.data.msg;
          this.listLoading = false;
        }
      });
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
}
</style>
